module.exports = __webpack_public_path__ + "img/3.8cc58232.png";